const songs = [
  {
    id: 0,
    img: "https://i.scdn.co/image/ab67616d00001e021895052324f123becdd0d53d",
    color: "#e68ba3",
    name: "Ice Cream",
    artists: [1, 0],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652696144/Ice_Cream_-_BLACKPINK_x_Selena_Gomez-_MyMp3Bhojpuri.In_chnnfl.mp3",
    duration: "2:55",
    views: 713413145,
    lyrics: 0,
  },
  {
    id: 1,
    img: "https://i.scdn.co/image/ab67616d00001e020e36690135fa1a30d048e604",
    color: "rgb(216, 104, 168)",
    name: "Come & Get It",
    artists: [0],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652696171/Come_And_Get_It_-_Selena_Gomez_320-_PagalWorld_jy9y9z.mp3",
    duration: "3:51",
    views: 613413145,
    lyrics: 1,
  },
  {
    id: 2,
    img: "https://i.scdn.co/image/ab67616d00001e026bc7473df6c9d1fd90972e84",
    color: "rgb(83, 83, 83)",
    name: "Kill Em With Kindness",
    artists: [0],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652696708/Selena_Gomez_-_.Kill_Em_With_Kindness_hcknid.mp3",
    duration: "3:37",
    views: 513213145,
    lyrics: 2,
  },
  {
    id: 3,
    img: "https://i.scdn.co/image/ab67616d0000b27359e699338051e7fec4f2139a",
    color: "rgb(120, 40, 48)",
    name: "Boyfriend",
    artists: [0],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652699846/Selena_Gomez_-_Boyfriend_wudq1l.mp3",
    duration: "2:41",
    views: 415413145,
    lyrics: 3,
  },
  {
    id: 4,
    img: "https://i.scdn.co/image/ab67616d0000b27359e699338051e7fec4f2139a",
    color: "rgb(120, 40, 48)",
    name: "Look At Her Now",
    artists: [0],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652700256/Look_At_Her_Now_-_Selena_Gomez_PagalWorld_j81x8w.mp3",
    duration: "2:42",
    views: 313413145,
    lyrics: 4,
  },
  {
    id: 5,
    img: "https://i.scdn.co/image/ab67616d0000b2731895052324f123becdd0d53d",
    color: "rgb(240, 144, 168)",
    name: "How You Like That",
    artists: [1],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652805385/How_You_Like_That_-_BlackPink_PagalWorld_kamsfs.mp3",
    duration: "3:00",
    views: 813413145,
    lyrics: 5,
  },
  {
    id: 6,
    img: "https://i.scdn.co/image/ab67616d0000b2732d602ab2d4acff0c2cf57683",
    color: "rgb(232, 184, 192)",
    name: "Kill This Love",
    artists: [1],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652805872/Kill_This_Love_Mp3_Song_Download-_NewViralSong.Com_o7z7mg.mp3",
    duration: "3:09",
    views: 913413145,
    lyrics: 6,
  },
  {
    id: 7,
    img: "https://i.scdn.co/image/ab67616d0000b27318a4a215052e9f396864bd73",
    color: "rgb(216, 120, 144)",
    name: "PLAYING WITH FIRE",
    artists: [1],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652806332/BLACKPINK_-_%EB%B6%88%EC%9E%A5%EB%82%9C_PLAYING_WITH_FIRE_129_kbps_hwwkjx.mp3",
    duration: "3:17",
    views: 413413145,
    lyrics: 7,
  },
  {
    id: 8,
    img: "https://i.scdn.co/image/ab67616d0000b27314d1e0d0aba77339c007ed92",
    color: "rgb(232, 152, 168)",
    name: "Forever Young",
    artists: [1],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652806624/BLACKPINK_-_Forever_Young_128_kbps_c7w02u.mp3",
    duration: "3:57",
    views: 813413145,
    lyrics: 8,
  },
  {
    id: 9,
    img: "https://i.scdn.co/image/ab67616d0000b2735ef878a782c987d38d82b605",
    color: "rgb(104, 136, 128)",
    name: "positions",
    artists: [2],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652807378/Ariana_Grande_-_Positions_yw3rqp.mp3",
    duration: "2:52",
    views: 613413145,
    lyrics: 9,
  },
  {
    id: 10,
    img: "https://i.scdn.co/image/ab67616d0000b273c3af0c2355c24ed7023cd394",
    color: "rgb(248, 208, 176)",
    name: "God is a woman",
    artists: [2],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652807781/Ariana_Grande_-_God_Is_A_Woman_talkglitz.tv_akcfsk.mp3",
    duration: "3:17",
    views: 713413145,
    lyrics: 10,
  },
  {
    id: 11,
    img: "https://i.scdn.co/image/ab67616d0000b27333342c57a9b2c4e04c97b3f5",
    color: "rgb(83, 83, 83)",
    name: "Into You",
    artists: [2],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652808067/Ariana_Grande_-_Into_You_128-_MastiMusic.Com_yjvhrb.mp3",
    duration: "4:04",
    views: 613413145,
    lyrics: 11,
  },
  {
    id: 12,
    img: "https://i.scdn.co/image/ab67616d0000b2735ef878a782c987d38d82b605",
    color: "rgb(104, 136, 128)",
    name: "34+35",
    artists: [2],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652808405/Ariana_Grande_-_34_35_Correctvibe.com_eh4tj6.mp3",
    duration: "2:53",
    views: 713413145,
    lyrics: 12,
  },
  {
    id: 13,
    img: "https://i.scdn.co/image/ab67616d0000b273c3af0c2355c24ed7023cd394",
    color: "rgb(248, 208, 176)",
    name: "no tears left to cry",
    artists: [2],
    song: "https://res.cloudinary.com/xander-ecommerce/video/upload/v1652808505/Ariana_Grande_-_No_Tears_Left_To_Cry_Talkglitz.tv__c4zu4c.mp3",
    duration: "3:25",
    views: 573413145,
    lyrics: 13,
  },
];

export default songs;
